import { createMutation, createQuery } from "@steto-care/steto-query";

import { MailPreferenceRepository } from "@/io/repository/MailPreferenceRepository.ts";
import { MailPreferenceUpdate, compareMailPreference } from "@/models/MailPreferenceModel.ts";

export class MailPreferenceQueries {
  constructor(private readonly mailPreference: MailPreferenceRepository = new MailPreferenceRepository()) {}

  /*******************************/
  /*********** QUERIES ***********/
  /*******************************/

  useMailPreference = createQuery(
    "mail-preference",
    ({}) => [],
    async () => (await this.mailPreference.getPreferences()).sort(compareMailPreference),
  );
  /*******************************/
  /********** MUTATIONS **********/
  /*******************************/

  useUpdatePreference = createMutation(
    "update-mail-preference",
    async (data: MailPreferenceUpdate) => this.mailPreference.updatePreferences(data),
    {
      onSuccess: (_, __, { client }) => {
        this.useMailPreference.invalidate(client, {});
      },
    },
  );
}
